import axios from 'axios';
import Vue from 'vue';

const posState = Vue.observable({
    items: [],
    loading: false,
});

let fetchPromise = null;
let debounceTimer = null;

function executeFetch() {
    posState.loading = true;
    fetchPromise = axios.get('/api/point-of-sale?list=true&all=true')
        .then(res => {
            posState.items = res.data;
            posState.loading = false;
            return res.data;
        })
        .catch(err => {
            fetchPromise = null;
            posState.loading = false;
        });
}

export default {
    getState() {
        return posState;
    },

    getPointsOfSale() {
        if (fetchPromise) {
            return;
        }

        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(executeFetch, 50);
    },
};
